<template>
    <div id="components-main-layout" v-if="check">
        <a-layout :style="{ zIndex: 1, height: '100%' }">
            <menu_sidebar>这里是sidebar</menu_sidebar>
            <a-layout :style="{ zIndex: 2 }">
                <header_bar>这里是header</header_bar>
                <a-layout-content :style="{padding:'0 20px'}">
                    <div>
                        <a-row :style="{marginTop:'10px',}">
                            <a-breadcrumb>
                                <a-breadcrumb-item>借款/报销单</a-breadcrumb-item>
                                <a-breadcrumb-item>详情</a-breadcrumb-item>
                            </a-breadcrumb>
                        </a-row>
                        <a-row>
                            <div style="background:#FFFFFF;width:100%;margin-top:10px;border-top:4px solid #CCCCCC;padding:10px;">
                                <a-row  :style="{margin:'15px 0 15px 0'}">
                                    <a-col :span="6" align="left"><span style="font-size:18px;">详情列表</span></a-col>
                                    <a-col :span="18" align="right">
                                        <router-link target="_blank" :to="{path:'pdf.php',query:{id:new_id}}" style="margin-right:10px;">打印</router-link>
                                        <a-button type="primary" @click="btn_new()" style="margin-left:10px;">新增详情</a-button>
                                    </a-col>
                                </a-row>
                                <a-row>
                                    <a-table
                                        :columns="columns"
                                        :data-source="data"
                                        bordered
                                        :pagination="pagination"
                                        :loading="loading"
                                        row-key="id"
                                        @change="PageChange"
                                    >
                                        <span slot="operator" slot-scope="id,record">
                                            <a-button type="link" @click="handleDel({detail_id:record.id})">删除</a-button>
                                        </span>
                                    </a-table>
                                    <input type="file" id='file' @change="getFile($event)" ref="filElem" name="file" style="display:none;" />
                                </a-row>
                            </div>
                        </a-row>
                    </div>
                </a-layout-content>
                <footer_bar>这里是footer</footer_bar>
            </a-layout>
        </a-layout>
        <div style="" class="form_bgbox" v-if="pop_form">
            <div class="form_boxin">
                <a-row>
                    <a-form-model
                        :form="form"
                        :model = "json_data2"
                        ref="ruleForm"
                        :label-col="{ span: 4,offset:1}"
                        :wrapper-col="{ span: 18 }"
                        :rules="rules"
                        :hideRequiredMark = false
                        :validateOnRuleChange = true
                    >
                        <a-col :span="24">
                            <a-form-model-item label="费用名称" prop="title">
                                <a-input
                                    placeholder="请填写费用名称"
                                    v-model="json_data2.title"
                                />
                            </a-form-model-item>
                        </a-col>
                        <a-col :span="24">
                            <a-form-model-item label="工作号" prop="work_no">
                                <a-input placeholder="请填写工作号" v-model="json_data2.work_no" />
                            </a-form-model-item>
                        </a-col>
                        <a-col :span="24">
                            <a-form-model-item label="新客户名称" prop="customer_name">
                                <a-input placeholder="请填写新客户名称" v-model="json_data2.customer_name" />
                            </a-form-model-item>
                        </a-col>
                        <a-col :span="24">
                            <a-form-model-item label="金额" prop="money" type="number">
                                <a-input placeholder="费用金额" v-model="json_data2.money" />
                            </a-form-model-item>
                        </a-col>
                        <a-col :span="24" align="right">
                            <a-button type="danger" @click="onClose" style="margin-right:10px;">关闭</a-button>
                            <a-button type="primary" @click="onSubmit">保存</a-button>
                        </a-col>
                    </a-form-model>
                </a-row>
            </div>
        </div>
    </div>
</template>

<script>
import menu_sidebar from '../components/menu_sidebar'
import header_bar from '../components/header'
import footer_bar from '../components/footer'
import axios from 'axios'
import Cookies from "js-cookie";

const columns = [
    {
        title: '费用名称',
        dataIndex: 'title',
        width:180,
        align:'center',
    },
    {
        title: '工作号',
        dataIndex: 'work_no',
        width:180,
        align:'center',
    },
    {
        title: '新客户简称',
        dataIndex: 'customer_name',
        ellipsis: true,
        align:'left',
    },
    {
        title: '金额',
        dataIndex: 'money',
        width: 210,
        align:'right',
    },
    {
        title: '操作',
        dataIndex: 'operators',
        width:150,
        align:'center',
        scopedSlots:{customRender:'operator'},
    },
];

export default {
    name: "bogus_detail",
    components:{
        menu_sidebar,
        header_bar,
        footer_bar,
    },
    data(){
        return {
            data:[],
            columns,
            current: ['23'],
            openKeys: ['2'],
            new_id:0,
            pagination: {
                total:0,
                defaultPageSize:10,
                size:'small',
            },
            loading: false,
            check:false,
            pop_form:false,
            json_data:{
                action:'bogus',
                type:'detail_detail',
                id:0,
                page:1,
                token:0,
            },
            form:{
                title:'12313',
            },
            rules:{
                title: [
                    { required: true, message: '请填写费用名称', trigger: 'blur' },
                ],
                work_no: [
                    { required: true, message: '请填写工作号', trigger: 'blur' },
                ],
                customer_name: [
                    { required: true, message: '请填写新客户名称', trigger: 'blur' },
                ],
                money: [
                    { required: true, message: '请填写金额', trigger: 'blur' },
                ],
            },
            formLayout: 'horizontal',
            json_data2:{
                action:'bogus',
                type:'detail_submit',
                token:0,
                id:0,
                work_no:'',
                customer_name:'',
                money:'',
                title:'',
            }
        };
    },
    mounted() {
        this.fetch();
    },
    beforeMount() {
        var token = Cookies.get('Token');

        var json_data = '{"action":"CheckToken","token":"'+token+'"}';
        let self = this;
        axios.post('/api/index.php',json_data)
            .then((response)=> {
                if(response.data.status!=1){
                    self.$router.push({path:'/login'})
                }else{
                    this.check = true;
                }
            })
            .catch(function (error) { // 请求失败处理
                console.log(error);
            });
        this.$store.commit("sidebar_current", ['23'])
        this.$store.commit("sidebar_openKeys", ['2'])
    },
    computed:{

    },
    methods:{
        PageChange(pagination) {
            this.fetch(pagination.current)
        },
        fetch(page){
            this.json_data.token = Cookies.get('Token');
            this.loading = true;
            this.json_data.id = this.$route.params.id;
            this.new_id = Cookies.get('Token')+this.$route.params.id;
            this.json_data.page = page;
            let self = this;
            if(this.$route.params.id != undefined) {
                axios.post("/api/index.php", this.json_data).then(response => {
                    if (response.data.status == 1) {
                        this.loading = false;
                        this.pagination.total = response.data.total
                        this.data = response.data.data
                    }else{
                        this.loading = false;
                        self.$message.error(response.message);
                    }
                })
            }else{
                self.$router.push({path:'/bogus'})
                //self.$message.error('请求 ID 无效');
            }
        },
        btn_new() {//
            this.pop_form = true;
        },
        onClose() {//
            this.pop_form = false;
        },
        onSubmit() {//提交数据
            //console.log(id);
            let self = this;
            this.json_data2.token = Cookies.get("Token");//读取
            this.json_data2.id =this.$route.params.id;

            this.$refs.ruleForm.validate(valid => {
                if(valid){
                    axios.post('/api/index.php',this.json_data2)
                        .then((response)=>{
                            if(response.data.status ==1){
                                this.pop_form = false;
                                this.pagination.total = response.data.total;
                                this.data = response.data.data;
                                this.json_data2.title = '';
                                this.json_data2.work_no = '';
                                this.json_data2.customer_name = '';
                                this.json_data2.money = '';
                            }else{
                                self.$message.error(response.data.message);
                            }
                        })
                        .catch(function(error){
                            self.$message.error(error);
                        })
                }else{
                    //console.log(valid)
                    return false;
                }
            })

        },
        handleDel(row) {
            let self = this;
            var Token = Cookies.get("Token");//读取
            var id =this.$route.params.id;
            var json_data = '{"action":"bogus","type":"detail_del_per","token":"'+Token+'","id":'+id+',"detail_id":'+row.detail_id+'}';
            var url = 'api/index.php';
            axios.post(url,json_data)
                .then((response)=>{
                    if(response.data.status==1){
                        self.$message.success(response.data.message);
                        this.pagination.total = response.data.total;
                        this.data = response.data.data;
                    }else{
                        self.$message.error(response.data.message);
                    }
                })
        },
    }
}
</script>

<style scoped>
.form_bgbox{width:100%;height:100%;background:rgba(0,0,0,.60);position: fixed;left:0;top:0;z-index: 99;}
.form_boxin{width:600px;height:350px;position:fixed;left:50%;top:50%;margin-left:-300px;margin-top:-300px;background:#FFFFFF;border-radius: 5px;padding:50px 10px 10px 10px;}
#components-main-layout{height:100%;width:100%;}
#components-main-layout {
    /*text-align: center;*/
}

#components-main-layout .ant-layout-sider {
    background: #E9EEF3;
    color: #fff;
}
#components-main-layout .ant-layout-content {
    /*background: #E9EEF3;*/
    color: #666666;
}
#components-main-layout > .ant-layout {
    margin-bottom: 48px;
}
#components-main-layout > .ant-layout:last-child {
    margin: 0;
}
</style>